var _defs, _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketpoolCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "reth-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0.25,
    stdDeviation: 0.3,
    floodColor: "#000",
    floodOpacity: 0.4
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rocket Pool ETH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E86200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#reth-shadow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 7.4,
    y: 9.1,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 7.2,
    fill: "#FFFFFF"
  }, "R"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.6,4.2) scale(0.55)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-2.6 3.1,0 0,1.7 -3.1,0",
    fill: "#FFFFFF"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketpoolCircle);
export default __webpack_public_path__ + "static/media/rocketpool-circle.7f7e86f5087f3ed4f1755491ec8fc092.svg";
export { ForwardRef as ReactComponent };